import { Select, type SelectProps } from '@any-ui-react/core';
import { PerformanceReviewQuarter } from '@/common/graphql';

type QuarterSelectProps = Omit<SelectProps, 'data'>;

const PerformanceReviewQuarterLabels: Record<PerformanceReviewQuarter, string> = {
  [PerformanceReviewQuarter.Q1Q2]: 'Q1/Q2',
  [PerformanceReviewQuarter.Q3Q4]: 'Q3/Q4',
};

const types = Object.keys(PerformanceReviewQuarterLabels).map(value => ({
  label: PerformanceReviewQuarterLabels[value as PerformanceReviewQuarter],
  value: value as PerformanceReviewQuarter,
}));

// Offset the centered text to the left so it visually balances against the Select's right-section icon
export const QuarterSelect = ({ ...props }: QuarterSelectProps) => (
  <Select data={types} {...props} classNames={{ input: 'text-center pr-[30px]', option: 'justify-center pr-[30px]' }} />
);
